import React from 'react';
import adv_meeting from '../assets/adv_meeting.jpeg';
import adv_meeting_2025_main from '../assets/adv_meeting_2025_main.png';
import adv_meeting_2025_kwibuka from '../assets/adv_meeting_2025_kwibuka.png';
import adv_meeting_2025_discussions from '../assets/adv_meeting_2025_discussions.png';
import adv_meeting_2025_rosette from '../assets/adv_meeting_2025_rosette.jpg';
import school_visit from '../assets/school_visit.png';
import oct_intake from '../assets/oct_intake.png';
import nov_agm from '../assets/nov_agm.jpg';
import supply_distribution_2026 from '../assets/supply_distrisbution_2026.jpeg';
import gisagara_happy_faces_2026 from '../assets/gisagara_happy_faces_2026.jpeg';
import student_and_asef_staff_2026 from '../assets/student_and_asef_staff_2026.jpeg';
import school_supplies_2026 from '../assets/school_supplies_2026.jpeg';
import inside_adv_meeting from '../assets/inside_adv_meeting.jpeg';
import s1_and_s4_students from '../assets/s1_and_s4_students.jpeg';
import students_wishing_happy_new_year from '../assets/students_wishing_happy_new_year.jpeg';
import july_advisory_meeting_2025 from '../assets/july_advisory_meeting_2025.jpeg';
import panel_discussion_2025 from '../assets/panel_discussion_2025.jpeg';
import tech_desk_2025 from '../assets/tech_desk_2025.jpeg';
import senior_six_students_2025 from '../assets/senior_six_students_2025.jpeg';
import term_two_visit_2025 from '../assets/term_two_visit_2025.jpeg';
import asef_staff_and_students_ttc_cyabingo from '../assets/asef_staff_and_students_ttc_cyabingo.jpeg';
import Academic_Year_School_Visits_2025_2026 from '../assets/Academic_Year_School_Visits_2025_2026.jpeg';
import TTC_Save_Students_Excited from '../assets/TTC_Save_Students_Excited.jpeg';
import TTC_Byumba_Students from '../assets/TTC_Byumba_Students.jpeg';
import St_Mary_High_School_Students from '../assets/St_Mary_High_School_Students .jpeg';
import Academic_Year_2026_AGM from '../assets/2026_AGM.jpeg';
import ASEF_Reunion_at_UR_Huye_Campus from '../assets/ASEF_Reunion_at_UR_Huye_Campus.jpeg';
import ASEF_Graduates from '../assets/ASEF Graduates.jpeg';
import Alumni_QR_Code from '../assets/Alumni_QR_Code.jpeg';
import Reunion_at_RICA from '../assets/Reunion_at_RICA.jpeg';
import Reunion_at_ALU from '../assets/Reunion_at_ALU.jpeg';

export const newsData = [
  {
    id: 1,
    image: nov_agm,
    title: '2023 November AGM',
    date: 'Feb 14, 2024',
    category: 'NEWS',
    paragraphs: [
      {
        text: 'Kigali, 150 graduates attended ,Musanze , 87 graduates attended, Burera, 20 graduates attended,Nyanza, 52 graduates attended.',
      },
      {
        text: 'Represented Universities: UR, RP, UGHE, ALU, KEPLER, CMU and MASTERCARD.',
      },
      {
        text: "The attendance was very good. Since graduates chose their locations to attend and not necessarily their districts of a long period.They danced different cultural songs and didn't want to leave the meeting location to keep the engagement. Graduates seemed interested to know more about the universities that were represented, especially ALU, and UGHE (due to fully funded scholarships). Use of English only was an obstacle for some, but it showed them how the applications in universities will be and they embraced the challenge!",
      },
      {
        text: 'CMU and Mastercard scholars: Led by an ASEF graduate called Jean Pierre Imanirumva, they came in Kigali and gave graduates information from different great universities and they guaranteed them assistance in application to Mastercard Foundation and other universities.',
      },
    ],
  },
  {
    id: 2,
    image: oct_intake,
    title: '2023 October New intake',
    date: 'Feb 14, 2024',
    category: 'NEWS',
    paragraphs: [
      {
        text: '330 students entered the program - It is the first time to take such a large number of new students.',
      },
      {
        text: 'Since the government of Rwanda is encouraging citizens to work hard and graduate from poverty, it is no longer allowed to use ubudehe category to select new beneficiaries. So ASEF had to work closely with MINALOC and local government to know the people qualified to be chosen as new students. It helped ASEF to get closer to District Vice Mayor Social Affaires.',
      },
      {
        text: 'As was done previously, ASEF worked with Sector Education Inspectors. Here are steps followed to take new students',
      },
      {
        text: 'Step 1: Get lists from SEIs. Students with at least the aggregate of 26, in primary and 40 in secondary.',
      },
      {
        text: 'Step 2: Analyze the lists ourselves and share them with Vice Mayor Social Affaires or District Directors in Charge of Social Affaires.',
      },
      {
        text: 'Step 3: Give final lists to SEIs and request them to tell students the day to come to districts for new intake.',
      },
      {
        text: 'Step 4: Select new students at the district and give them supplies so that they can go to school as soon as possible.',
      },
      {
        text: 'Overview of 2023 new intake',
      },
      {
        text: "It took time to verify lists from SEIs since many of the student's families were not on the list of under poverty",
      },
      {
        text: 'ASEF agreed with districts that, during selection, priority would be given to those on the list from districts of families under poverty.',
      },
      {
        text: 'In general, new intake went well and 330 students entered the program',
      },
    ],
  },
  {
    id: 3,
    image: school_visit,
    title: '2023 November school visits',
    date: 'Feb 14, 2024',
    category: 'NEWS',
    paragraphs: [
      {
        text: 'In total, 174 students were visited in 20 schools from November 07th to 23rd. The priority was new schools and those not visited in last academic year. We were happy to visit new schools like International Technical School of Kigali, MIPC, and Nyanza Hills Academy. Before using English in Advisory meetings, ASEF introduced it first in school visits. Students enjoyed the new challenge and said that they will be using English while talking to each other. However, some of them said that some of their teachers still teach them in Kinyarwanda. During these school visits, there was more engagement with students through ice breaking activities, giving them interviews, and taking videos of different activities.',
      },
      {
        text: 'We are looking forward to visit more schools in term 2 since it had impact to our students.',
      },
    ],
  },
  {
    id: 4,
    image: adv_meeting,
    title:
      '2023 December Advisory meetings It was the First time to conduct meetings in English and most',
    date: 'Feb 14, 2024',
    category: 'NEWS',
    paragraphs: [
      {
        text: 'It was the First time to conduct meetings in English and most of the students were shy but left the meeting place positively and ready to practice English at school to be able to interact with ASEF staff and interns in April 2024.',
      },
      {
        text: 'In general, term 1 performance for our students was good and they were encouraged to keep working hard in term 2 since many of them were new to their schools. Small christmas gifts composed by candies and toffees were given to students and they made students very happy and were ending meetings on a smiling note!',
      },
      {
        text: 'It was the first time to meet many students in one district. For example, in Rulindo we met 169 students, and still, we finished meeting them before 1 pm',
      },
      {
        text: '52 students missed the meeting or came without docs but we were able to meet them somewhere else (41 came to the office in Jan 2024) 17 potential new interns interviewed and introduced to students. In general they did great job and we are positive to find good ones this year.',
      },
      {
        text: "We can't forget that our social media were being updated daily by reels and other posts.",
      },
    ],
  },
  {
    id: 5,
    category: 'NEWS',
    image: adv_meeting_2025_main,
    date: 'Jun 24, 2025',
    title: '2025 APRIL Advisory Meetings Experience',
    paragraphs: [
      {
        text: 'April advisory meetings were a whole vibe as the pictures shows. The meetings started on Thursday April 10th till Tuesday April 15th. Following up from December advisory meetings, April AM were conducted in 3 groups which were stars composed by students in top 5 positions of their class, advancing composed of students from 6th position to top half of their class, and growth zone composed by students belongs to the bottom half of their class. Briefly these were the numbers of students in each group: 449 Stars - 517 Advancing - 234 Growth Zone.',
      },
      {
        text: 'Group discussions emphasized on the groups needs, such as providing different opportunities for stars and improving, setting self-challenging goals for advancing, and reminding growth zone members about the ASEF code of conduct regarding academic performance. The discussions in this group also focused on encouraging members to improve, as well as helping them identify their strengths and weaknesses to enhance their performance',
      },
      {
        image: adv_meeting_2025_discussions,
      },
      {
        text: 'Due to the period we were in, ASEF staff together with students took time to remember all the 1994 genocide against the tutsi victims and encouraged the students’ to always remember what happened and fight whoever that would want them to support genocide ideology with all their efforts.',
      },
      {
        image: adv_meeting_2025_kwibuka,
      },
      {
        text: 'The ASEF Advisory meetings impacts a lot on ASEF students as it is an opportunity for the students to assess and track their ongoing academic year performance, improvement, development, have their questions answered, advised by ASEF staffs and interns on different academic related topics and decision making like choosing what to study in A’level for O’level students, early university preparations for A’level students, English language proficiency improvement and sharing with them the best possible opportunities like Isomo academy camp, Gashora girls academy, Rwanda coding academy and much more... By comparing term 1 and term 2 performance as well, you can see that there was a slight improvement where around 20 students moved from growth zone group going to advancing and improvement in performance and class marks in general.',
      },
      {
        header: 'Mushambokazi Rosette’s April Advisory Meeting Experience:',
      },
      {
        image: adv_meeting_2025_rosette,
        dimensions: 'h-[300px]',
      },
      {
        text: 'My name is Rosette MUSHAMBOKAZI, An ASEF Intern! The April advisory meeting was an eye-opening and inspiring experience with the groups (stars, advancing and growth zone), regarding their performance, students engaged in meaningful discussions about their academic journey, personal growth, and future goals.',
      },
      {
        text: 'We shared ideas, offered advice, and learned from one another.It created a space where everyone felt heard, valued, and supported.This meeting successfully left lasting memories and outstanding stories from students.',
      },
      {
        text: 'It also reminded students who were not performing well that they are risking their future and continued support from ASEF. Students walked away motivated, with fresh perspectives and a renewed sense of purpose. Truly, it was a memorable and impactful gathering.',
      },
      {
        text: 'Click the link below to watch the full highlights',
        linkObj: {
          new_line: true,
          link: 'https://youtu.be/K0FTPMcdeLk?si=InR6SlhFYoskrqTc',
        },
      },
    ],
  },
  {
    id: 6,
    category: 'NEWS',
    image: term_two_visit_2025,
    date: 'Jan 28, 2026',
    title: '2025 -2026 Academic year, term two school visits',
    paragraphs: [
      {
        text: 'Following term one school visit where 387 students from 34 schools were visited, in the third week of January, ASEF initiated Term Two school visits for the 2025–2026 academic year. The team was delighted to connect with students, discuss their academic, extracurricular, and social lives, and engage with school administrations, who were as supportive as always.',
      },

      {
        text: 'During this week, 41 students from seven schools were reached, and more students will be visited throughout the term.',
      },

      {
        text: (
          <>
            <br />
            Diane Umutoniwase, one of the ASEF staff members, conducted the
            visits, said:
            <i>
              “The visits were amazing, discovering new places and, most
              importantly, connecting with students and school administrations.
              What I enjoyed most was interacting with students, as these visits
              create space to engage with them beyond academics and to better
              understand their life experiences.”
            </i>
          </>
        ),
      },

      {
        image: asef_staff_and_students_ttc_cyabingo,
        image_description:
          'Umutoniwase Diane (ASEF staff) with ASEF students from TTC Cyabingo',
      },

      {
        text: 'Find the term one school visits highlight here:',
        linkObj: {
          new_line: true,
          link: 'https://youtu.be/Dyazk_up1VA?si=2DZTm5lI1tFo0EC4',
        },
      },
    ],
  },
  {
    id: 7,
    category: 'NEWS',
    image: july_advisory_meeting_2025,
    date: 'Jan 28, 2026',
    title: 'July 2025 ASEF - Advisory Meetings',
    paragraphs: [
      {
        text: 'This marked the end of the 2024–2025 academic year. Students from all ASEF districts of operation were excited to meet one another at their respective meeting locations. They came eager to share their school experiences, and ASEF staff were ready to listen and support them.',
      },

      {
        text: 'Students were divided into small groups according to their levels of study and given different discussion topics. Later, panel discussions were conducted based on these topics.',
      },
      {
        image: panel_discussion_2025,
        image_description: 'Ruhango district; During panel discussions',
      },

      {
        text: 'It was inspiring to see O’Level students stand out by leading panel discussions, sharing constructive ideas, and confidently engaging with, and learning from their A’Level peers.',
      },
      {
        text: 'At ASEF, we value students’ ideas from a young age, which is why many of our students continue to stand out wherever they go.',
      },
      {
        text: 'As part of the meetings, technology was not left behind. Students were given time to ask questions, explore various features of MacBook computers, and interact with ASEF staff throughout the sessions.',
      },

      {
        image: tech_desk_2025,
        image_description: 'Ruhango district; Students on tech desk',
      },

      {
        text: 'With the majority of students performing well academically, they were encouraged to keep aiming high. Those who did not perform as expected were reminded to refocus and get back on track. Senior Six candidates were informed about exciting opportunities ahead and encouraged to actively pursue them. As always, education remains fundamental.',
      },

      {
        image: senior_six_students_2025,
        image_description: 'Burera district; group of Senior six students',
      },

      {
        text: 'Watch the meeting highlights here:',
        linkObj: {
          new_line: true,
          link: 'https://youtu.be/dKSai2okrrI?si=PZ5wZt9Rlvv45Ymi',
        },
      },
    ],
  },
  {
    id: 8,
    category: 'NEWS',
    image: inside_adv_meeting,
    date: 'Jan 28, 2026',
    title: 'Inside 2025 December Advisory Meetings',
    paragraphs: [
      {
        text: 'It was that time again, Advisory Meetings! Done at the end of each academic term, ASEF meets with its students to evaluate the last term, engage with them, and have fun. This time, we made it happen too!',
      },
      {
        text: 'On December 24th, 29th, and 30th, ASEF met with its students from all ten districts of operation, namely Rwamagana, Kamonyi, Ruhango, and Rulindo on the 24th; Gisagara, Nyabihu, and Burera on the 29th; and Gakenke, Musanze, and Nyanza on the 30th of December 2025, successfully meeting over 1,300 students.',
      },

      {
        text: ' This time, it was different. Conducting meetings during the festive season, students were happy to meet both ASEF staff and interns. Meetings were conducted through group discussions after verifying whether each student had brought their original report and parent sheet (commonly known as Babyeyi).',
      },
      {
        image: s1_and_s4_students,
        image_description: 'S1 & S4 Students in a group',
      },

      {
        text: 'Students from S1 were paired with those from S4 to set New Year goals together and discuss ways to overcome challenges faced in their new schools. S2 students were paired with S5 students to discuss learning strategies and succeeding in some of the most challenging high school years. Lastly, S3 and S6 students shared experiences and tips on national examination preparation.',
      },

      {
        text: 'As it was the rainy season, meetings were conducted in a timely manner, allowing students to go home early by serving those who arrived first. As it is always done at ASEF, we prioritize students’ insights about the service. This time, students were able to give feedback and suggestions on the meetings, with most testifying that the meetings were well conducted and timely.',
      },

      {
        text: 'In this end of first term advisory meetings, it was an opportunity for academic reflection, sharing tips, and setting academic goals for the New Year and the new term. The meetings ended on a good note with New Year wishes, keeping the spirit open for the next advisory meetings.',
      },
      {
        image: students_wishing_happy_new_year,
        image_description: 'Students wishing others happy new year',
      },

      {
        text: 'Don’t miss out this interesting highlight video of these meetings:',
        linkObj: {
          new_line: true,
          link: 'https://youtu.be/maJ0fYKnWcc?si=rq3gKLwanAiBwHB7',
        },
      },
    ],
  },
  {
    id: 9,
    category: 'NEWS',
    image: supply_distribution_2026,
    date: 'Jan 28, 2026',
    title: '2025-2026 Academic year supply distribution Meetings',
    paragraphs: [
      {
        text: 'In September 2025, ASEF met with its students across all districts of operation to distribute school supplies ahead of the 2025-2026 academic year. Students from all districts, including both current beneficiaries and the new 2025 cohort, were excited to attend the meetings.',
      },
      {
        text: 'Many parents accompanied their children to help carry the supplies. The smiles on every student’s face reflected both gratitude and readiness for the new academic year.',
      },
      {
        image: gisagara_happy_faces_2026,
        image_description:
          'Gisagara district; Happy faces of students after receiving school supplies',
      },
      {
        text: (
          <>
            <i>
              “We had no hope for Angélique’s studies after she passed the
              national examinations. But now that ASEF is supporting her, we
              believe she will succeed. Angélique is the first child in our
              family to attend a boarding school, and we are very happy for this
              support.”
            </i>
            <br />— Uwayezu Angeliques’ mother (2025 cohort)
          </>
        ),
      },

      {
        image: student_and_asef_staff_2026,
        image_description:
          'Uwayezu Angelique (student) and Aline Kamanzi (ASEF staff)',
      },
      {
        text: 'Currently, ASEF supports 1,344 students in 236 schools nationwide, covering both tuition fees and school supplies. ASEF remains committed to supporting bright yet vulnerable students, helping them build a better future and achieve their dreams.',
      },
      {
        image: school_supplies_2026,
        image_description:
          'Nyanza district; Students receiving school supplies',
      },

      {
        text: 'You can watch Supply Distribution Meeting video highlight here: ',
        linkObj: {
          new_line: true,
          link: 'https://youtu.be/K0FTPMcdeLk?si=InR6SlhFYoskrqTc',
        },
      },
    ],
  },
  {
    id: 10,
    category: 'NEWS',
    image: Academic_Year_School_Visits_2025_2026,
    date: 'March 6, 2026',
    title: 'End of Term Two 2025-2026 Academic Year School Visits',
    paragraphs: [
      {
        text: 'The week of March 2nd to March 6th marked the end of Term Two school visits. The team managed to visit 277 students from 25 schools this term.',
      },
      {
        image: TTC_Save_Students_Excited,
        image_description: 'TTC Save Students excited for the ASEF team',
      },
      {
        text: 'Students were very excited to meet the team and welcomed them with smiles, ready to engage. We were very happy to learn from all the students and understand how they are putting effort into their studies, achieving different academic milestones, and participating in extracurricular activities.',
      },

      {
        text: 'It was very good to see how some of them took the lead in different clubs operating within the school and participate in debates and entrepreneurial challenges that help them put their skills into practice.',
      },

      {
        image: TTC_Byumba_Students,
        image_description: 'ASEF students at TTC Byumba',
      },
      {
        text: 'As it has always been our mission, ASEF will continue supporting young people through education, as it helps them shape their future and, in return, the future of the whole continent. School visits are among the key ASEF programs, and we can’t wait to resume them in Term Three.',
      },

      {
        image: St_Mary_High_School_Students,
        image_description: "ASEF Students at St Mary's High School Kiruhura",
      },
      // {
      //   image: student_and_asef_staff_2026,
      //   image_description: 'ASEF students at St Phillipe Neri Gisagara',
      // },
    ],
  },

  {
    id: 11,
    category: 'NEWS',
    image: Academic_Year_2026_AGM,
    date: 'March 6, 2026',
    title: '2026 Annual Graduates Meetings',
    paragraphs: [
      {
        text: 'ASEF has over 2,700 graduates since its official start, all over the globe. All graduates have taken different life paths after high school completion, and ASEF values each and everyone’s choices. As a way of reuniting with our graduates, ASEF organized the 2026 ASEF Alumni Reunion, which took place at different universities where some graduates studied and others are currently studying.',
      },
      {
        text: 'During the reunion, we had time to discuss various topics. Graduates were happy to share their university application processes, academic life, milestones they are achieving, challenges along the way, lifestyles, future expectations toward the job market, and the impact ASEF may have had on one or more of these areas.',
      },
      {
        text: ' It was a vibrant reunion. Many smiling faces, active engagement, discussions, and one-on-one conversations testified to the impact of the activity on everyone who attended.',
      },

      {
        image: ASEF_Reunion_at_UR_Huye_Campus,
        image_description:
          'Group Discussions during ASEF Reunion at UR Huye Campus',
      },

      {
        text: 'Speaking to graduates, most of them mentioned that they didn’t know each other but then they have reconnected and shared contacts! ',
      },

      {
        image: ASEF_Graduates,
        image_description:
          'ASEF Graduates; Amizero Nadia and Ukundase Emmanuelie',
      },
      {
        text: 'During the reunion, we were also pleased to have graduates participate in a short survey we are conducting about our graduates. If you are an ASEF graduate from any year and anywhere, we would also greatly appreciate your participation (you will learn more about the survey after opening the link). Wherever life has taken you, we are always happy to celebrate your academic and professional successes and understand your challenges. Please remember to click “Submit” so your responses are recorded.',
      },

      {
        text: 'You can use the link below to access the survey:',
        linkObj: {
          new_line: false,
          link: 'https://docs.google.com/forms/d/e/1FAIpQLSeeo3xTiRMtpe4Kt5mfWPxSSwOFjs9n-OeKlRbyae3ncWlvWQ/viewform',
        },
      },
      {
        text: 'Or scan the code below to participate',
      },

      {
        image: Alumni_QR_Code,
        dimensions:
          'w-[200px] h-[200px] md:w-[260px] md:h-[260px] lg:w-[300px] lg:h-[300px]',
      },

      {
        text: 'Currently, ASEF has reunited with graduates from University of Rwanda – Institute of Conservation Agriculture (RICA), African Leadership University, University of Rwanda – Huye Campus, RP Huye College, and Catholic University of Rwanda – Gisagara Campus. We will continuously be happy to reconnect with our graduates, learn from them, and extract valuable advice from their interactions that can help our current students.',
      },
      {
        image: Reunion_at_RICA,
        image_description: 'ASEF Reunion at RICA',
      },

      {
        image: Reunion_at_ALU,
        image_description: 'ASEF Reunion at ALU',
      },
    ],
  },
];

export const getNewsPreviewText = (newsItem) => {
  const firstParagraph = newsItem?.paragraphs?.[0];
  if (!firstParagraph || typeof firstParagraph.text !== 'string') {
    return '';
  }
  return firstParagraph.text;
};

export const getSortedNewsData = () =>
  [...newsData].sort((firstItem, secondItem) => firstItem.id - secondItem.id);
